export const config = Object.freeze({
  url: Object.freeze({
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api'
  }),
  enablePreflight: process.env.REACT_APP_ENABLE_PREFLIGHT !== 'false'
});
